export enum ContractsStatuses {
	ACTIVE = "ACTIVE",
	DISABLED = "DISABLED",
}

export enum ContractChannelSplitLabel {
	HOTELISE = "Hotelise",
	OWNER = "Owner",
}

export interface ContractChannelSplitOption {
	value: number;
	label: ContractChannelSplitLabel;
}

export interface ContractChannelSplit {
	airbnb: number;
	booking: number;
	vrbo: number;
	direct: number;
}

export type MarkupAppliedTo = "total" | "channel_fee" | "cleaning";

export interface ChannelMarkup {
	id: string;
	name: string;
	percent: number;
	appliedTo: MarkupAppliedTo;
}

export type ChannelKey = "airbnb" | "booking" | "vrbo" | "direct";

export enum SubscriptionFrequency {
	YEARLY = "yearly",
	MONTHLY = "monthly",
	WEEKLY = "weekly",
}

export interface ContractSubscription {
	enabled: boolean;
	amount: number;
	currency: string;
	frequency: SubscriptionFrequency;
}

export enum VatDisplayMode {
	FEE_PLUS_VAT = "fee_plus_vat",
	FEE_INCLUDES_VAT = "fee_includes_vat",
}

export interface Contract {
	id?: string;
	propertyId?: string;
	status?: ContractsStatuses;
	hoteliseFee?: number;
	vat?: number;
	vatDisplayMode?: VatDisplayMode;
	channelSplit?: ContractChannelSplit;
	channelMarkups?: Partial<Record<ChannelKey, ChannelMarkup[]>>;
	doNotClaimCleaningCost?: boolean;
	subscriptions?: Partial<Record<string, ContractSubscription>>;
	notes?: string;
}
